import React, { FC, RefObject } from 'react'
import { Direction } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { classes } from './__index.utils'
import { RadioList } from '@utils/request'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import * as utilsList from './__index.utils'
import * as formUtils from '@pages/auth/__index.utils'
import {
	PHONE_NUMBER_REGEX,
	POSTAL_CODE_REGEX
} from '@pages/auth/profile/__index.utils'
import MaskedThousandsSeparatorInput from '../inputs/textWithThousandsSeparator.inputs'
import TextAreaInput from '../inputs/textarea.inputs'
import DateFilterInput from '../inputs/datefilter.input'
import { joinClasses } from '@utils/styles'

const Step5InformationsTravaux = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false
	// *******
}) => {
	const {
		whatToDo,
		requestAs,

		// **********************
		//*********** */
		isWorkDueToDisaster,
		workDueToDisasterPrecision,
		approximateCostOfWork,
		isTreeCuttingRequired,
		additionalInfoQ28,
		workStartDate,
		workEndDate,
		whoWillBeInChargeOfWork,
		entrepreneurUnknown1,
		companyNameExecutingWork,
		companyNEQNumber,
		companyRBQNumber,
		companyRepresentativeName,
		companyRepresentativePhoneNumber,
		companyRepresentativeEmail,
		companyAddress,
		companyCity,
		companyPostalCode
	} = formInputs

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const radioListWhoWillBeInChargeOfWork: RadioList[] =
		utilsList.radioListWhoWillBeInChargeOfWork(pageAssets)

	const getLabelFromList = (list, value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_information_on_the_work}
				</h4>
			)}

			<RadioInput
				name={isWorkDueToDisaster.name}
				label={isWorkDueToDisaster.label}
				value={isWorkDueToDisaster.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(isWorkDueToDisaster.name)}
				required={isWorkDueToDisaster.required}
				ref={isWorkDueToDisaster.ref as RefObject<HTMLInputElement>}
				hasBackgroundWrapper={true}
				onChange={(value) => updateInput(isWorkDueToDisaster.name, value)}
				classWrapper={classes.reducedMarginBottom}
				isSummaryStep={isSummaryStep}
			/>

			{isWorkDueToDisaster.value == radioListYesNo[0].value && (
				<>
					<TextInput
						id={workDueToDisasterPrecision.name}
						label={workDueToDisasterPrecision.label}
						value={workDueToDisasterPrecision.value}
						onChange={(value) =>
							updateInput(workDueToDisasterPrecision.name, value)
						}
						hasError={errors!.includes(workDueToDisasterPrecision.name)}
						required={workDueToDisasterPrecision.required}
						ref={workDueToDisasterPrecision.ref as RefObject<HTMLInputElement>}
						maxCharacters={100}
						isSummaryStep={isSummaryStep}
					/>
				</>
			)}

			<MaskedThousandsSeparatorInput
				id={approximateCostOfWork.name}
				label={approximateCostOfWork.label}
				value={approximateCostOfWork.value}
				onChange={(value: string) => {
					// debugger
					updateInput(approximateCostOfWork.name, value?.toString())
				}}
				hasError={errors.includes(approximateCostOfWork.name)}
				required={approximateCostOfWork.required}
				ref={approximateCostOfWork.ref as RefObject<HTMLInputElement>}
				errors={errors}
				setError={onFixError}
				displayCurrency
				maxCharacters={9}
				isSummaryStep={isSummaryStep}
			/>

			<RadioInput
				name={isTreeCuttingRequired.name}
				label={isTreeCuttingRequired.label}
				value={isTreeCuttingRequired.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(isTreeCuttingRequired.name)}
				required={isTreeCuttingRequired.required}
				ref={isTreeCuttingRequired.ref as RefObject<HTMLInputElement>}
				hasBackgroundWrapper={true}
				onChange={(value) => updateInput(isTreeCuttingRequired.name, value)}
				description={isTreeCuttingRequired.description}
				isSummaryStep={isSummaryStep}
			/>

			<TextAreaInput
				id={additionalInfoQ28.name}
				label={additionalInfoQ28.label}
				value={additionalInfoQ28.value}
				onChange={(value) => updateInput(additionalInfoQ28.name, value)}
				hasError={errors!.includes(additionalInfoQ28.name)}
				required={additionalInfoQ28.required}
				ref={additionalInfoQ28.ref as RefObject<HTMLTextAreaElement>}
				maxCharacters={500}
				hasDescriptionLabel={additionalInfoQ28.description}
				displayDescriptionTop
				descriptionAlignment="left"
				rows={4}
				isSummaryStep={isSummaryStep}
			/>

			{/* Dates des travaux */}
			{(!isSummaryStep ||
				(isSummaryStep && (workStartDate.value || workEndDate.value))) && (
				<h5 className={pageUtils.classes.h5}>
					{
						pageAssets?.request_form_buildingConstructionOrAdditionPermit_work_dates
					}
				</h5>
			)}

			<div
				className={joinClasses([
					pageUtils.classes.fieldsContainer,
					'fieldsContainer'
				])}
			>
				<DateFilterInput
					id={workStartDate.name}
					label={workStartDate.label}
					value={workStartDate.value}
					onChange={(value) => updateInput(workStartDate.name, value)}
					hasError={errors!.includes(workStartDate.name)}
					required={workStartDate.required}
					dateFormat="dd/MM/yyyy"
					minDate={new Date()}
					isSummaryStep={isSummaryStep}
				/>

				<DateFilterInput
					id={workEndDate.name}
					label={workEndDate.label}
					value={workEndDate.value}
					onChange={(value) => updateInput(workEndDate.name, value)}
					hasError={errors!.includes(workEndDate.name)}
					required={workEndDate.required}
					dateFormat="dd/MM/yyyy"
					minDate={new Date(workStartDate.value + 'T12:00:00')}
					disabled={workStartDate.value == ''}
					isSummaryStep={isSummaryStep}
				/>
			</div>

			{/* Entrepreneur exécutant les travaux de construction. */}
			<h5 className={pageUtils.classes.h5}>
				{
					pageAssets?.request_form_buildingConstructionOrAdditionPermit_entrepreneur_executing_work
				}
			</h5>

			<RadioInput
				name={whoWillBeInChargeOfWork.name}
				label={whoWillBeInChargeOfWork.label}
				value={whoWillBeInChargeOfWork.value}
				list={
					requestAs.value == radioListWhoWillBeInChargeOfWork[0].value
						? radioListWhoWillBeInChargeOfWork
						: radioListWhoWillBeInChargeOfWork.slice(1)
				}
				direction={Direction.vertical}
				hasError={errors!.includes(whoWillBeInChargeOfWork.name)}
				required={whoWillBeInChargeOfWork.required}
				ref={whoWillBeInChargeOfWork.ref as RefObject<HTMLInputElement>}
				hasBackgroundWrapper={true}
				onChange={(value) => updateInput(whoWillBeInChargeOfWork.name, value)}
				isSummaryStep={isSummaryStep}
			/>

			{/* <br /> */}
			{[
				radioListWhoWillBeInChargeOfWork[1].value,
				radioListWhoWillBeInChargeOfWork[2].value
			].includes(whoWillBeInChargeOfWork.value) && (
				<>
					{isSummaryStep && (
						<>
							<div>
								<strong>{entrepreneurUnknown1.label}</strong>
								<br />
								<span className={pageUtils.classes.answerURB}>
									{getLabelFromList(
										radioListYesNo,
										entrepreneurUnknown1.value?.toString() || String(false)
									)}
								</span>
							</div>
						</>
					)}
					{!isSummaryStep && (
						<>
							<div className={classes.checkbox2Container}>
								<span
									className={classes.checkboxWrapper}
									style={{ marginTop: '10px' }}
								>
									<input
										onChange={(e: any) =>
											updateInput(entrepreneurUnknown1.name, e.target.checked)
										}
										value={entrepreneurUnknown1.value?.toString()}
										className={classes.checkbox2}
										checked={entrepreneurUnknown1.value.toString() == 'true'}
										type="checkbox"
										name={entrepreneurUnknown1.name}
										id={entrepreneurUnknown1.labelKey}
									/>
									<label
										className={classes.checkbox2Label}
										htmlFor={entrepreneurUnknown1.labelKey}
									>
										{entrepreneurUnknown1.label}
									</label>
								</span>
							</div>
						</>
					)}
				</>
			)}

			<TextInput
				id={companyNameExecutingWork.name}
				label={companyNameExecutingWork.label}
				value={companyNameExecutingWork.value}
				onChange={(value) => updateInput(companyNameExecutingWork.name, value)}
				hasError={errors!.includes(companyNameExecutingWork.name)}
				required={companyNameExecutingWork.required}
				ref={companyNameExecutingWork.ref as RefObject<HTMLInputElement>}
				maxCharacters={50}
				isSummaryStep={isSummaryStep}
			/>
			<div
				className={joinClasses([
					pageUtils.classes.fieldsContainer,
					'fieldsContainer'
				])}
			>
				<MaskedTextInput
					id={companyNEQNumber.name}
					label={companyNEQNumber.label}
					value={companyNEQNumber.value}
					onChange={(value) => {
						// debugger
						updateInput(companyNEQNumber.name, value)
					}}
					hasError={errors!.includes(companyNEQNumber.name)}
					required={companyNEQNumber.required}
					ref={companyNEQNumber.ref as RefObject<HTMLInputElement>}
					max={10}
					min={10}
					mask="0000000000"
					errors={errors}
					setError={onFixError}
					placeholder="1111111111"
					schema={/^\d{10}$/}
					isSummaryStep={isSummaryStep}
				/>

				<MaskedTextInput
					id={companyRBQNumber.name}
					label={companyRBQNumber.label}
					value={companyRBQNumber.value}
					onChange={(value) => {
						// debugger
						updateInput(companyRBQNumber.name, value)
					}}
					hasError={errors!.includes(companyRBQNumber.name)}
					required={companyRBQNumber.required}
					ref={companyRBQNumber.ref as RefObject<HTMLInputElement>}
					max={12}
					min={12}
					mask="0000-0000-00"
					placeholder="1111-1111-11"
					errors={errors}
					setError={onFixError}
					schema={/^\d{4}-\d{4}-\d{2}$/}
					isSummaryStep={isSummaryStep}
				/>
			</div>

			{/* Représentant(e) ou personne contact */}
			{(!isSummaryStep ||
				(isSummaryStep &&
					(companyRepresentativeName.value ||
						companyRepresentativePhoneNumber.value ||
						companyRepresentativeEmail.value))) && (
				<h6 className={classes.h6}>
					{
						pageAssets?.request_form_buildingConstructionOrAdditionPermit_representative_or_contact_person
					}
				</h6>
			)}

			<TextInput
				id={companyRepresentativeName.name}
				label={companyRepresentativeName.label}
				value={companyRepresentativeName.value}
				onChange={(value) => updateInput(companyRepresentativeName.name, value)}
				hasError={errors!.includes(companyRepresentativeName.name)}
				required={companyRepresentativeName.required}
				ref={companyRepresentativeName.ref as RefObject<HTMLInputElement>}
				maxCharacters={100}
				isSummaryStep={isSummaryStep}
			/>

			<div
				className={joinClasses([
					pageUtils.classes.fieldsContainer,
					'fieldsContainer'
				])}
			>
				<MaskedTextInput
					id={companyRepresentativePhoneNumber.name}
					label={companyRepresentativePhoneNumber.label}
					value={companyRepresentativePhoneNumber.value}
					onChange={(value) => {
						// debugger
						updateInput(companyRepresentativePhoneNumber.name, value)
					}}
					hasError={errors?.includes(companyRepresentativePhoneNumber.name)}
					type="tel"
					min={10}
					max={14}
					mask={formUtils.MASKS.phoneNumber}
					placeholder={formUtils.MASKS.phoneNumber}
					errors={errors ? errors : []}
					setError={onFixError}
					schema={PHONE_NUMBER_REGEX}
					required={companyRepresentativePhoneNumber.required}
					ref={
						companyRepresentativePhoneNumber.ref as RefObject<HTMLInputElement>
					}
					isSummaryStep={isSummaryStep}
				/>

				<TextInput
					id={companyRepresentativeEmail.name}
					label={companyRepresentativeEmail.label}
					value={companyRepresentativeEmail.value}
					onChange={(value) =>
						updateInput(companyRepresentativeEmail.name, value)
					}
					hasError={errors!.includes(companyRepresentativeEmail.name)}
					required={companyRepresentativeEmail.required}
					ref={companyRepresentativeEmail.ref as RefObject<HTMLInputElement>}
					maxCharacters={100}
					type="email"
					schema={formUtils.MASKS.email}
					schemaErrorText={pageAssets.label_emailErrorText}
					onSetError={onFixError}
					isSummaryStep={isSummaryStep}
				/>
			</div>

			{/* Adresse de l'entreprise */}
			{(!isSummaryStep ||
				(isSummaryStep &&
					(companyAddress.value ||
						companyCity.value ||
						companyPostalCode.value))) && (
				<h6 className={classes.h6}>
					{
						pageAssets?.request_form_buildingConstructionOrAdditionPermit_company_address
					}
				</h6>
			)}

			<TextInput
				id={companyAddress.name}
				label={companyAddress.label}
				value={companyAddress.value}
				onChange={(value) => updateInput(companyAddress.name, value)}
				hasError={errors!.includes(companyAddress.name)}
				required={companyAddress.required}
				ref={companyAddress.ref as RefObject<HTMLInputElement>}
				maxCharacters={50}
				isSummaryStep={isSummaryStep}
			/>

			<div
				className={joinClasses([
					pageUtils.classes.fieldsContainer,
					'fieldsContainer'
				])}
			>
				<TextInput
					id={companyCity.name}
					label={companyCity.label}
					value={companyCity.value}
					onChange={(value) => updateInput(companyCity.name, value)}
					hasError={errors!.includes(companyCity.name)}
					required={companyCity.required}
					ref={companyCity.ref as RefObject<HTMLInputElement>}
					maxCharacters={50}
					isSummaryStep={isSummaryStep}
				/>

				<MaskedTextInput
					id={companyPostalCode.name}
					label={companyPostalCode.label}
					value={companyPostalCode.value}
					onChange={(value: string) => {
						const upValue =
							typeof value === 'string' ? value.toUpperCase() : value
						// debugger
						updateInput(companyPostalCode.name, value.toUpperCase())
					}}
					hasError={errors!.includes(companyPostalCode.name)}
					required={companyPostalCode.required}
					ref={companyPostalCode.ref as RefObject<HTMLInputElement>}
					max={7}
					min={7}
					mask={formUtils.MASKS.postalCode}
					placeholder="A1A 1A1"
					errors={errors}
					setError={onFixError}
					schema={POSTAL_CODE_REGEX}
					isSummaryStep={isSummaryStep}
				/>
			</div>
		</>
	)
}

export default Step5InformationsTravaux
